export const GET_TRANSPORT_BUS_STOPS_REQUEST = 'GET_TRANSPORT_BUS_STOPS_REQUEST'
export const GET_TRANSPORT_BUS_STOPS_ERROR = 'GET_TRANSPORT_BUS_STOPS_ERROR'
export const GET_TRANSPORT_BUS_STOPS_SUCCESS = 'GET_TRANSPORT_BUS_STOPS_SUCCESS'

export const GET_TRANSPORT_BUS_ROUTES_REQUEST = 'GET_TRANSPORT_BUS_ROUTES_REQUEST'
export const GET_TRANSPORT_BUS_ROUTES_ERROR = 'GET_TRANSPORT_BUS_ROUTES_ERROR'
export const GET_TRANSPORT_BUS_ROUTES_SUCCESS = 'GET_TRANSPORT_BUS_ROUTES_SUCCESS'

export const GET_TRANSPORT_BUS_STOPS_ETA_REQUEST = 'GET_TRANSPORT_BUS_STOPS_ETA_REQUEST'
export const GET_TRANSPORT_BUS_STOPS_ETA_ERROR = 'GET_TRANSPORT_BUS_STOPS_ETA_ERROR'
export const GET_TRANSPORT_BUS_STOPS_ETA_SUCCESS = 'GET_TRANSPORT_BUS_STOPS_ETA_SUCCESS'

export const GET_TRANSPORT_BUS_ROUTES_ETA_REQUEST = 'GET_TRANSPORT_BUS_ROUTES_ETA_REQUEST'
export const GET_TRANSPORT_BUS_ROUTES_ETA_ERROR = 'GET_TRANSPORT_BUS_ROUTES_ETA_ERROR'
export const GET_TRANSPORT_BUS_ROUTES_ETA_SUCCESS = 'GET_TRANSPORT_BUS_ROUTES_ETA_SUCCESS'

export const GET_TRANSPORT_BUS_ROUTE_STOPS_REQUEST = 'GET_TRANSPORT_BUS_ROUTE_STOPS_REQUEST'
export const GET_TRANSPORT_BUS_ROUTE_STOPS_ERROR = 'GET_TRANSPORT_BUS_ROUTE_STOPS_ERROR'
export const GET_TRANSPORT_BUS_ROUTE_STOPS_SUCCESS = 'GET_TRANSPORT_BUS_ROUTE_STOPS_SUCCESS'

export const GET_TRANSPORT_LOCATIONS_REQUEST = 'GET_TRANSPORT_LOCATIONS_REQUEST'
export const GET_TRANSPORT_LOCATIONS_ERROR = 'GET_TRANSPORT_LOCATIONS_ERROR'
export const GET_TRANSPORT_LOCATIONS_SUCCESS = 'GET_TRANSPORT_LOCATIONS_SUCCESS'

export const GET_TRANSPORT_DESTINATIONS_REQUEST = 'GET_TRANSPORT_DESTINATIONS_REQUEST'
export const GET_TRANSPORT_DESTINATIONS_ERROR = 'GET_TRANSPORT_DESTINATIONS_ERROR'
export const GET_TRANSPORT_DESTINATIONS_SUCCESS = 'GET_TRANSPORT_DESTINATIONS_SUCCESS'

export const GET_TRANSPORT_LOCATION_ETA_REQUEST = 'GET_TRANSPORT_LOCATION_ETA_REQUEST'
export const GET_TRANSPORT_LOCATION_ETA_ERROR = 'GET_TRANSPORT_LOCATION_ETA_ERROR'
export const GET_TRANSPORT_LOCATION_ETA_SUCCESS = 'GET_TRANSPORT_LOCATION_ETA_SUCCESS'

export const GET_SHUTTLE_SCHEDULES_REQUEST = 'GET_SHUTTLE_SCHEDULES_REQUEST'
export const GET_SHUTTLE_SCHEDULES_ERROR = 'GET_SHUTTLE_SCHEDULES_ERROR'
export const GET_SHUTTLE_SCHEDULES_SUCCESS = 'GET_SHUTTLE_SCHEDULES_SUCCESS'

export const RESET_TRANSPORT_PAGE = 'RESET_TRANSPORT_PAGE'
export const RESET_TRANSPORT_META = 'RESET_TRANSPORT_META'